import { useState } from "react";
import { useTranslation } from "react-i18next";
// Internal dependencies
import { mapCoupon } from "./mappers";
import Actions from "../../../Actions";
import logger from "../../../utils/LoggerFrontend";
// Hook
function useCoupons({ organization, selectedChannels, lifeTimeBudget }) {
  const { t } = useTranslation();
  const [validCoupon, setValidCoupon] = useState();

  function validateCoupon(couponCode) {
    if (!couponCode) {
      Actions.addNotification(t("No coupon code"), "error");
      return;
    }

    const campaignData = {
      channels: selectedChannels.map((channel) => channel.channel_short_name),
      lifeTimeBudget,
      organizationId: organization.id
    };

    // Make the request to validate the coupon
    Actions.validateCampaignCoupon({ couponCode, campaignData });

    // The request has finished without errors
    Actions.validateCampaignCoupon.completed.listen(({ payload }) => {
      const { coupon, validity } = payload;
      const { discount } = coupon;

      logger.log("fetchCouponValidity:validateCampaignCoupon", "called", {
        discount,
        validity
      });

      if (!validity?.value) {
        Actions.addNotification(t("Invalid coupon") + ": " + validity?.reason, "error");
        return;
      }

      const orgaDiscount = parseInt(organization.discount || 0, 10);
      const couponDiscount = parseInt(discount.value || 0, 10);

      if (orgaDiscount > couponDiscount) {
        Actions.addNotification(
          t(
            "Coupon is valid but was not applied because the existing organization discount rate of {{orgaDiscount}}% is bigger than the coupon discount rate of {{couponDiscount}}%",
            { orgaDiscount, couponDiscount }
          ),
          "warning",
          true
        );
        return;
      }

      const couponMapped = mapCoupon(coupon);
      setValidCoupon(couponMapped);

      Actions.addNotification(t("Coupon has been applied"));
    });

    // The request has failed
    Actions.validateCampaignCoupon.failed.listen((response) => {
      logger.log("error:fetchCouponValidity:validateCampaignCoupon:failed", "error", {
        ...response,
        couponCode
      });
      Actions.addNotification(t("Could not validate coupon"), "error");
    });
  }

  function deleteCoupon() {
    setValidCoupon();
    Actions.addNotification(t("Coupon has been removed"));
  }

  return { validateCoupon, validCoupon, deleteCoupon };
}

export default useCoupons;
